import { c as _c } from "react/compiler-runtime";
import { ConfirmationEmailInterface } from 'modules/digital-product/types/confirmation-email-interface';
import React, { FC } from 'react';
import DashboardMailEditor from 'shared/components/dashboard-mail-editor';
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block';
import { EmailErrorType } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
type Props = {
  onChange: (data: ConfirmationEmailInterface) => void;
  errors: EmailErrorType;
  tempState: ConfirmationEmailInterface;
};
export const FILE_LINKS_SUBSTITUTE = 'downloadable_file_links';
export const PRODUCT_NAME_SUBSTITUTE = 'product_name';
export const ConfirmationEmailEditor: FC<Props> = t0 => {
  const $ = _c(26);
  const {
    onChange,
    errors,
    tempState
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.store.product.download.substitutions.customer_name");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      slug: "customer_name",
      name: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.store.product.download.substitutions.my_username");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      slug: "my_username",
      name: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("dashboard.store.product.download.substitutions.product_name");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      slug: PRODUCT_NAME_SUBSTITUTE,
      name: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.store.product.download.substitutions.product_files");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      slug: FILE_LINKS_SUBSTITUTE,
      name: t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = [t2, t4, t6, t8];
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const productDownloadSubstitutes = t9;
  let t10;
  if ($[21] !== errors || $[22] !== onChange || $[23] !== productDownloadSubstitutes || $[24] !== tempState) {
    t10 = <DashboardMailEditor additionalSubstitutes={productDownloadSubstitutes} withoutAttachments={true} isPreFetching={false} errors={errors} tempState={tempState} onChangeEmail={onChange} inModal={true} />;
    $[21] = errors;
    $[22] = onChange;
    $[23] = productDownloadSubstitutes;
    $[24] = tempState;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};